<template>
  <div
    :class="getSizeClass()"
    :style="{ borderColor: getTheme.fore }"
    ref="fig"
  >
    <ViaPunctiShield v-if="viaPunctiTermination" :index="figureId"/>
    <div class="pof" v-if="isPoF"><PartOfFortune size="0.7em"/></div>
    <div @click="toggle('fire')">
      <FigureLine
        :fid="this.figureId"
        :is-active="isLineActive('fire')"
        :is-editable="isEditable"
        :is-house="this.isHouse"
      />
    </div>
    <div @click="toggle('air')">
      <FigureLine
        :fid="this.figureId"
        :is-active="isLineActive('air')"
        :is-editable="isEditable"
        :is-house="this.isHouse"
      />
    </div>
    <div @click="toggle('water')">
      <FigureLine
        :fid="this.figureId"
        :is-active="isLineActive('water')"
        :is-editable="isEditable"
        :is-house="this.isHouse"
      />
    </div>
    <div @click="toggle('earth')">
      <FigureLine
        :fid="this.figureId"
        :is-active="isLineActive('earth')"
        :is-editable="isEditable"
        :is-house="this.isHouse"
      />
    </div>
    <div class="index" v-if="isIndex"><PartOfSpirit size="0.8em"/></div>
    <div class="figure-label" v-if="figureId >= 13 && figureId <= 16" v-html="figureLabel"></div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Anime from 'animejs'
import Names from '../utils/names'
import FigureLine from './FigureLine'
import ViaPunctiShield from './ViaPunctiShield'
import PartOfFortune from './PartOfFortune'
import PartOfSpirit from './PartOfSpirit'

export default {
  name: 'Figure',
  components: {
    FigureLine,
    ViaPunctiShield,
    PartOfFortune,
    PartOfSpirit
  },
  props: {
    figureId: Number,
    isEditable: Boolean,
    isBorderless: Boolean,
    isHouse: Boolean
  },
  mounted () {
    if (this.figureId >= 1 && this.figureId <= 4 && !this.isHouse) {
      const timeline = Anime.timeline()

      timeline.add({
        targets: this.$refs.fig,
        opacity: 0,
        duration: 300,
        easing: 'easeInQuad',
        delay: 800 + (this.figureId * 100)
      })

      timeline.add({
        targets: this.$refs.fig,
        opacity: 1,
        duration: 300,
        easing: 'easeOutQuad'
      })
    }
  },
  computed: {
    ...mapGetters(['getTheme']),
    isPoF () {
      return this.figureId === this.$store.getters.getPoF && this.isHouse
    },
    isIndex () {
      return this.figureId === this.$store.getters.getIndex && this.isHouse
    },
    viaPunctiTermination () {
      if (this.figureId > 8) return false
      if (this.isHouse) return false
      return true
    },
    figureLabel () {
      return Names.getNameForFigure(this.$store.getters.getFigureById(this.figureId))
    }
  },
  methods: {
    toggle (elem) {
      if (this.isEditable) {
        this.$store.commit({type: 'toggleFigureElem', id: this.figureId, elem})
      }
    },
    isLineActive (elem) {
      return this.$store.getters.getFigureById(this.figureId)[elem]
    },
    getSizeClass () {
      let stylesObj = {}
      stylesObj.figure = true
      
      if (this.isBorderless) {
        stylesObj['mother-daughter'] = true
      } else {
        stylesObj['figure-border'] = true

        if (this.figureId === 1 || this.figureId === 9 || this.figureId === 13 || this.figureId === 15) {
          stylesObj['right-border'] = true
        }

        if (this.figureId === 15) {
          stylesObj['bottom-border'] = true
        }

        if (this.figureId >= 0 && this.figureId <= 8) {
          stylesObj['mother-daughter'] = true
        }
  
        if (this.figureId >= 9 && this.figureId <= 12) {
          stylesObj.niece = true
        }
  
        if (this.figureId >= 13 && this.figureId <= 14) {
          stylesObj.witness = true
        }
  
        if (this.figureId === 15) {
          stylesObj.judge = true
        }
      }

      return stylesObj
    }
  }
}
</script>

<style scoped lang="scss">
$border-width: 1px;
$border-style: solid;

.figure {
  text-align: center;
  box-sizing: border-box;
  cursor: default;
  position: relative;
  height: 6.25rem;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.figure-border {
  border-top-width: $border-width;
  border-top-style: $border-style;
  border-left-width: $border-width;
  border-left-style: $border-style;
}

.right-border {
  border-right-width: $border-width;
  border-right-style: $border-style;
}

.bottom-border {
  border-bottom-width: $border-width;
  border-bottom-style: $border-style;
}

.mother-daughter {
  width: 50px;

  .pof {
    position: absolute;
    top: 0.5rem;
    left: 0;
    right: 0;
    display: flex;
    justify-content: center;
  }

  .index {
    position: absolute;
    bottom: 0.5rem;
    left: 0;
    right: 0;
    display: flex;
    justify-content: center;
  }
}

.niece {
  width: 100px;
}

.witness {
  width: 200px;
}

.judge {
  width: 400px;
}

.figure-label {
  font-size: 0.8rem;
}
</style>
